import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const ImageIcon = memo(({ style, className }: SVGProps) => {
  return (
    <svg viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" style={style} className={className}>
      <defs>
        <clipPath id="g0wi5d205a">
          <path d="M1920 0v1080H0V0h1920z" />
        </clipPath>
        <clipPath id="1gs8y213xb">
          <path d="M13.6 0C14.925 0 16 1.063 16 2.375v7.917c0 1.311-1.075 2.375-2.4 2.375H2.4c-1.325 0-2.4-1.064-2.4-2.375V2.375C0 1.063 1.075 0 2.4 0zM5.36 5.771a.806.806 0 0 0-1.12 0L1.6 8.376v1.916c0 .437.358.791.8.791h8.328zm6.4 1.584a.806.806 0 0 0-1.12 0l-.704.696 3.048 3.032h.616c.442 0 .8-.354.8-.791v-.333zm1.84-5.772H2.4c-.442 0-.8.355-.8.792v3.768l1.504-1.48c.947-.9 2.445-.9 3.392 0L8.8 6.943l.704-.697c.947-.9 2.445-.9 3.392 0l1.504 1.48V2.376a.796.796 0 0 0-.8-.792z" />
        </clipPath>
      </defs>
      <g clipPath="url(#g0wi5d205a)" transform="translate(-422 -331)">
        <g clipPath="url(#1gs8y213xb)" transform="translate(422.5 333.167)">
          <path d="M0 0h16v12.667H0V0z" />
        </g>
      </g>
    </svg>
  )
})
